import React from 'react';

export const TypeBoolean: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2.5"
      y="4"
      width="11"
      height="8"
      rx="4"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="9.49512" cy="8" r="2.25" fill="currentColor" />
  </svg>
);
